import React from 'react';
import PropTypes from 'prop-types';

import './Placeholder.less';

export const Placeholder = function({extraClasses = ''}) {
    return (
        <div className={`Placeholder ${extraClasses}`}>
            <div className="Placeholder__inner" />
        </div>
    );
};

Placeholder.propTypes = {
    extraClass: PropTypes.string
};
